<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div
          style="text-align: center;width: 100%; background-color: #efefef;border-radius: 5px;"
          v-if="row.fabricStatus === 'Q' && row.approvalStatus === 'P'"
        >
          <span
            @click="review(row)"
            class="action-button view-button"
            v-if="allow('S')"
          >
            {{ $l('menu_text_review') || '信息审核' }}
          </span>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayFabricName="{ row }">
        <TableLabel :value="row.fabricName" />
        <TableLabel :value="row.fabricNameEn" />
        <TableLabel label="NO" :value="row.fabricNo" />
      </template>
      <template v-slot:displayFabricSeriesName="{ row }">
        <TableLabel :value="row.fabricSeriesName" />
        <TableLabel :value="row.fabricSeriesNameEn" />
        <TableLabel label="系列号" :value="row.fabricSeriesNo" />
      </template>
      <template v-slot:fabricStatus="{ row }">
        <div style="display: flex;">
          <el-tag
            class="mr-2"
            size="mini"
            :type="
              row.fabricStatus === 'Y'
                ? 'success'
                : row.fabricStatus === 'Q'
                ? 'primary'
                : 'danger'
            "
          >
            {{ row.v_fabricStatus }}
          </el-tag>
          <el-tag
            v-if="row.approvalStatus"
            size="mini"
            effect="plain"
            :type="
              row.approvalStatus === 'Y'
                ? 'success'
                : row.approvalStatus === 'P'
                ? 'primary'
                : 'danger'
            "
          >
            {{ row.v_approvalStatus }}
          </el-tag>
        </div>
      </template>

      <template v-slot:displayWid="{ row }">
        <TableLabel
          :label="$l('table_label_wid') || '门幅'"
          :value="`${row.wid || 0} ${row.widUnit}`"
        />
        <TableLabel
          :label="$l('table_label_fabricWeight') || '克重'"
          :value="`${row.fabricWeight || 0} ${row.fabricWeightUnit}`"
        />
      </template>
      <template v-slot:displayFabricContent="{ row }">
        <TableLabel :value="row.fabricContent" />
        <TableLabel :value="row.fabricContentEn" />
      </template>

      <template v-slot:displayPrice="{ row }">
        <span>
          {{ row.unitPrice }} {{ $l('table_label_unitPriceUnit') || '元' }}/
          {{ row.v_fabricUnit }}
        </span>
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {},
  methods: {
    async review({ fabricCode, fabricNo }) {
      this.$emit('openEditPage', {
        pageType: 'review',
        params: { fabricCode },
        query: { fabricNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.action-button {
  width: 30px !important;
  height: 30px !important;
  font-size: 18px !important;
  text-align: center;
  line-height: 30px !important;
  cursor: pointer;

  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.action-button.view-button {
  width: 60px !important;
  font-size: 13px !important;
}

// .vxe-table--render-default .vxe-body--row.row--hover {
.action-button:hover {
  color: #007bff !important;
  background-color: #e7f1fe !important;
}
// }
</style>
